import React from 'react';
import { isAndroidCapacitor } from '../../utils/platformUtils';
import '../../styles/fixed-layout-ads.css';

const AD_CLIENT = 'ca-pub-1511890644353474';

function AdSenseUnit({ slot }) {
    if (!slot) return null;

    return (
        <ins
            className="adsbygoogle"
            style={{ display: 'block' }}
            data-ad-client={AD_CLIENT}
            data-ad-slot={slot}
            data-ad-format="auto"
            data-full-width-responsive="true"
        />
    );
}

/**
 * Fixed-layout AdSense shell used by form pages and blog posts.
 * Desktop web: sticky right sidebar. Phone web: bottom responsive banner.
 * Capacitor Android: no AdSense (AdMob handles the app).
 */
export default function FixedLayoutAds({
    topSlot,
    bottomSlot,
    sidebarSlot,
    fullWidth = false,
    children,
}) {
    const hideAds = isAndroidCapacitor();
    const mainClassName = fullWidth
        ? 'msv-fixed-layout-ads__main is-full-width'
        : 'msv-fixed-layout-ads__main';

    return (
        <div className="msv-fixed-layout-ads">
            <div className={mainClassName}>
                {!hideAds && topSlot && (
                    <div className="msv-fixed-layout-ads__top" id="mobile-top-ad">
                        <AdSenseUnit slot={topSlot} />
                    </div>
                )}
                {children}
                {!hideAds && bottomSlot && (
                    <div className="msv-fixed-layout-ads__bottom" id="mobile-bottom-ad">
                        <AdSenseUnit slot={bottomSlot} />
                    </div>
                )}
            </div>
            {!hideAds && sidebarSlot && (
                <div className="msv-fixed-layout-ads__sidebar" id="ad-container-right-banner">
                    <AdSenseUnit slot={sidebarSlot} />
                </div>
            )}
        </div>
    );
}
